<template>
    <div class="layout align-center justify-center wrap container text-xs-center">
        <v-flex class="xs12 sm12 md12">
            <div>
                <v-card class="card card-pricing card-plain">
                    <div class="m-portlet__head" style="border-bottom: 1px solid #ebedf2;">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title" style="width: 100%">
                                <h3 class="m-portlet__head-text" style="float: initial;text-align: start;padding: 30px;">
                                    Support message
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body" style="padding: 30px;text-align: start">
                        <div class="row">
                            <form>
                                <v-text-field
                                        v-model="email"
                                        label="E-mail"
                                        data-vv-name="email"
                                        required
                                ></v-text-field>
                                <v-textarea
                                        v-model="message"
                                        data-vv-name="message"
                                        name="input-7-1"
                                        label="Message"
                                ></v-textarea>

                                <v-btn @click="submit">submit</v-btn>
                                <v-btn @click="clear">clear</v-btn>
                            </form>
                        </div>
                    </div>
                </v-card>
            </div>
        </v-flex>
    </div>

</template>
<script>
    import {  VIcon, VFlex, VCard, VBtn ,VTextField,VTextarea } from 'vuetify/lib';
    export default {
        name: "Support",
        components: {
            VIcon,
            VFlex,
            VCard,
            VBtn,
            VTextField,
            VTextarea
        },
        data: () => ({
            message: '',
            email: ''
        }),

        mounted () {

        },

        methods: {
            submit () {

            },
            clear () {
                this.message = '';
                this.email = '';
            }
        }
    }
</script>

<style scoped>
    h5, .h5 {
        font-size: 1.25rem;
    }
    h6, .h6 {
        font-size: 1rem;
    }
</style>